import i18n from '../lib/i18n'

export const sectors = [
  {
    key: 'landwirtschaft-forstwirtschaft-und-fischerei',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.landwirtschaft-forstwirtschaft-und-fischerei'
      )
    },
    immediateReportingObligation: true,
  },
  {
    key: 'bergbau-und-gewinnung-von-steinen-und-erden',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.bergbau-und-gewinnung-von-steinen-und-erden'
      )
    },
    immediateReportingObligation: false,
  },
  {
    key: 'verarbeitendes-gewerbe',
    get label() {
      return i18n.t('frontend:onboarding.sector.verarbeitendes-gewerbe')
    },
    immediateReportingObligation: true,
  },
  {
    key: 'energieversorgung',
    get label() {
      return i18n.t('frontend:onboarding.sector.energieversorgung')
    },
    immediateReportingObligation: false,
  },
  {
    key: 'wasserversorgung-und-abwasserentsorgung',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.wasserversorgung-und-abwasserentsorgung'
      )
    },
    immediateReportingObligation: false,
  },
  {
    key: 'baugewerbe-und-bauindustrie',
    get label() {
      return i18n.t('frontend:onboarding.sector.baugewerbe-und-bauindustrie')
    },
    immediateReportingObligation: true,
  },
  {
    key: 'gross-und-einzelhandel',
    get label() {
      return i18n.t('frontend:onboarding.sector.gross-und-einzelhandel')
    },
    immediateReportingObligation: false,
  },
  {
    key: 'gastgewerbe',
    get label() {
      return i18n.t('frontend:onboarding.sector.gastgewerbe')
    },
    immediateReportingObligation: true,
  },
  {
    key: 'verkehr-und-logistik',
    get label() {
      return i18n.t('frontend:onboarding.sector.verkehr-und-logistik')
    },
    immediateReportingObligation: true,
  },
  {
    key: 'informations-und-kommunikationstechnologie',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.informations-und-kommunikationstechnologie'
      )
    },
    immediateReportingObligation: false,
  },
  {
    key: 'finanz-und-versicherungsdienstleistungen',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.finanz-und-versicherungsdienstleistungen'
      )
    },
    immediateReportingObligation: false,
  },
  {
    key: 'immobilienwirtschaft',
    get label() {
      return i18n.t('frontend:onboarding.sector.immobilienwirtschaft')
    },
    immediateReportingObligation: false,
  },
  {
    key: 'gesundheitswesen-und-sozialwesen',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.gesundheitswesen-und-sozialwesen'
      )
    },
    immediateReportingObligation: false,
  },
  {
    key: 'kultur-unterhaltung-und-freizeit',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.kultur-unterhaltung-und-freizeit'
      )
    },
    immediateReportingObligation: true,
  },
  {
    key: 'erziehung-und-unterricht',
    get label() {
      return i18n.t('frontend:onboarding.sector.erziehung-und-unterricht')
    },
    immediateReportingObligation: false,
  },
  {
    key: 'wissenschaft-und-forschung',
    get label() {
      return i18n.t('frontend:onboarding.sector.wissenschaft-und-forschung')
    },
    immediateReportingObligation: false,
  },
  {
    key: 'offentliche-verwaltung-und-verteidigung',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.offentliche-verwaltung-und-verteidigung'
      )
    },
    immediateReportingObligation: false,
  },
  {
    key: 'wach-und-sicherheitsdienste',
    get label() {
      return i18n.t('frontend:onboarding.sector.wach-und-sicherheitsdienste')
    },
    immediateReportingObligation: true,
  },
  {
    key: 'gebaudereinigung',
    get label() {
      return i18n.t('frontend:onboarding.sector.gebaudereinigung')
    },
    immediateReportingObligation: true,
  },
  {
    key: 'erbringung-von-sonstigen-wirtschaftlichen-dienstleistungen',
    get label() {
      return i18n.t(
        'frontend:onboarding.sector.erbringung-von-sonstigen-wirtschaftlichen-dienstleistungen'
      )
    },
    immediateReportingObligation: false,
  },
]

export const immediateReportingObligationSectors = [
  {
    get name() {
      return i18n.t('frontend:onboarding.immediateReportingSector.schausteller')
    },
  },
  {
    get name() {
      return i18n.t('frontend:onboarding.immediateReportingSector.gaststaette')
    },
  },
  {
    get name() {
      return i18n.t(
        'frontend:onboarding.immediateReportingSector.hotelsUndPensionen'
      )
    },
  },
  {
    get name() {
      return i18n.t('frontend:onboarding.immediateReportingSector.baugewerbe')
    },
  },
  {
    get name() {
      return i18n.t(
        'frontend:onboarding.immediateReportingSector.speditionTransportLogistik'
      )
    },
  },
  {
    get name() {
      return i18n.t(
        'frontend:onboarding.immediateReportingSector.personenbefoerderung'
      )
    },
  },
  {
    get name() {
      return i18n.t(
        'frontend:onboarding.immediateReportingSector.forstwirtschaft'
      )
    },
  },
  {
    get name() {
      return i18n.t(
        'frontend:onboarding.immediateReportingSector.gebaeudereinigung'
      )
    },
  },
  {
    get name() {
      return i18n.t(
        'frontend:onboarding.immediateReportingSector.fleischwirtschaft'
      )
    },
  },
  {
    get name() {
      return i18n.t('frontend:onboarding.immediateReportingSector.eventMesse')
    },
  },
  {
    get name() {
      return i18n.t(
        'frontend:onboarding.immediateReportingSector.wachUndSicherheit'
      )
    },
  },
]
